
window.axios.interceptors.response.use(
	function (response)
	{
		clearError();

		if (response.data.flashes && response.data.flashes.length > 0)
		{
			for (flash of response.data.flashes)
			{
				if (flash.level && flash.message)
				{
					addFlashAlert(flash.level, flash.message);
				}
			}
		}

		return response;
	},
	function (thrown)
	{
		clearError();

		if (window.axios.isCancel(thrown) || !thrown.response)
		{
			console.log('Canceled request: ' + thrown.message);
			return Promise.reject(thrown);
		}

		if (thrown.response)
		{
			if (thrown.response.status === 401)
			{
				window.location.href = urls.relogin;
				return Promise.reject(thrown);
			}

			if (thrown.response.status === 422 && thrown.response.data && thrown.response.data.errors)
			{
				showFormErrors(thrown.response.data.errors);
				if (thrown.response.data.warnings && thrown.response.data.warnings.length > 0)
				{
					addFlashAlert('warning', thrown.response.data.warnings.map(htmlEncode).join('<br />'));
				}

				return Promise.reject(thrown);
			}

			if (thrown.response.headers['x-contact-us'] && thrown.response.headers['x-contact-us'] == 1)
			{
				addFlashAlert('warning', vue.data.translations.error.contact_us);
				return Promise.reject(thrown);
			}
		}

		if (thrown.response && thrown.response.data && thrown.response.data.message)
		{
			addFlashAlert('danger', thrown.response.data.message);
		}
		else
		{
			addFlashAlert('danger', thrown.message);
		}

		console.log('Error in ajax request: ', thrown);

		// thrown.response.data
		// thrown.response.status
		// thrown.response.statusText

		return Promise.reject(thrown);
	}
);
